module.exports = __webpack_public_path__ + "img/vicky_eqrcode_lite.208bc12e.jpg";